import React from "react";
import Link from "../routes/Home/components/Link";
import * as ROUTES from "../routes/Home/constants/routes";
import Break from "./Break";
import DiagonalUpArrow from "./Icons/DiagonalUpArrow";

export default function ContactAndFooter() {
  return (
    <>
      <Break />

      <section className="say-hello">
        <Link
          to="mailto:info@mediaartslab.com"
          target="_blank"
          rel="noreferrer"
        >
          Say Hello{" "}
          <div className="small-arrow">
            <DiagonalUpArrow />
          </div>
        </Link>
        <Link
          to="https://www.linkedin.com/company/tbwamedia-arts-lab/"
          target="_blank"
          rel="noreferrer"
        >
          Linkedin{" "}
          <div className="small-arrow">
            <DiagonalUpArrow />
          </div>
        </Link>
        <Link
          to="https://www.instagram.com/tbwamal/"
          target="_blank"
          rel="noreferrer"
        >
          Instagram{" "}
          <div className="small-arrow">
            <DiagonalUpArrow />
          </div>
        </Link>
      </section>

      <Break />

      <footer>
        <Link to={ROUTES.CCPA}>CCPA</Link>
        <Link to={ROUTES.HOME_PRIVACY_POLICY}>Privacy Policy</Link>
        <Link to={ROUTES.HOME_TOS}>Terms of Service</Link>
        <div>© TBWA\MEDIA ARTS LAB {new Date().getFullYear()}</div>
        <Link to={ROUTES.HOME_COOKIES}>Cookies Policy</Link>
        <div id="ot-sdk-btn" class="ot-sdk-show-settings">
          Cookie Settings
        </div>
        <Link to={ROUTES.SCAM_ALERTS}>Scam Alerts</Link>
      </footer>
    </>
  );
}
